import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "a-counter" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "2",
  viewBox: "0 0 12 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.166668 1.83335V0.166687H11.8333V1.83335H0.166668Z",
    fill: "white"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "45",
  height: "45",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.7 28.8698L16.4136 27.5833L21.5594 22.4375L16.4136 17.2916L17.7 16.0051L22.8459 21.151L27.9918 16.0051L29.2782 17.2916L24.1324 22.4375L29.2782 27.5833L27.9918 28.8698L22.8459 23.7239L17.7 28.8698Z",
    fill: "white"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "a-counter__info" }
const _hoisted_9 = {
  key: 0,
  class: "loader"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "a-counter__info-measure" }
const _hoisted_12 = {
  key: 0,
  class: "a-counter__info-sum"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.16667 11.8334V6.83335H0.166672V5.16669H5.16667V0.166687H6.83334V5.16669H11.8333V6.83335H6.83334V11.8334H5.16667Z",
    fill: "white"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.value == 0)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "card__btn card__btn-full",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change(_ctx.ratio)))
        }, " В коризну "))
      : _createCommentVNode("", true),
    (_ctx.value > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.count > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: _ctx.loading,
                class: "card__btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.change(-_ctx.ratio)))
              }, _hoisted_4, 8, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.count < 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: _ctx.loading,
                class: "card__btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteItem && _ctx.deleteItem(...args)))
              }, _hoisted_7, 8, _hoisted_5))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.value) + " " + _toDisplayString(_ctx.measure), 1),
                  (_ctx.price)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.priceFormat(parseFloat(_ctx.price * _ctx.value,2))), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            class: "card__btn",
            disabled: _ctx.loading || _ctx.value + _ctx.ratio > _ctx.max,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.change(_ctx.ratio)))
          }, _hoisted_15, 8, _hoisted_13)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}